import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { MainService } from 'src/app/services/main/main.service';
import * as REGEX from '../../../shared/regex';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

/* tslint:disable:no-shadowed-variable */
declare const grecaptcha: any;
@Component({
  selector: 'app-customer-landing-page',
  templateUrl: './customer-landing-page.component.html',
  styleUrls: ['./customer-landing-page.component.scss']
})

export class CustomerLandingPageComponent implements OnInit {
  user = this.fb.group({
    email: ['', [Validators.required, Validators.pattern(REGEX.Email)]],
    business_email: ['', [Validators.pattern(REGEX.Email)]],
    name: ['', [Validators.required]],
    service: ['', [Validators.required]],
    preferred_business: [''],
    business_phone: [''],
    phone: ['', [Validators.required]],
  });
  mask = REGEX.mobile_mask;
  showThankyou =  false;
  recaptchaToken: any;
  // tslint:disable-next-line:variable-name
  site_key = environment.google_captcha_sitekey;
  currentYear: number = new Date().getFullYear();
  @ViewChild('myModal', { static: false }) modalTemplate!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  isMobileView = false;

  constructor(
    public mainService: MainService,
    public fb: FormBuilder,
    public _ActiveRoute: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.isMobileView  = window.innerWidth < 768;
    if (this.isMobileView) {
      if (this.showThankyou) {
        setTimeout(() => {
          this.openDialog();
        }, 100);
      }
      this.showThankyou = false;
    }
  }


  submitForm() {
    if (this.user.invalid) {
      this.user.markAllAsTouched();
      this.user.markAsDirty();
      return;
    }

    grecaptcha.ready(() => {
      grecaptcha.execute(this.site_key, { action: 'submit' }).then((token: string) => {
        this.recaptchaToken = token;
        const data = {
          email: this.user.value.email.replace(/\s/g, '').toLowerCase(),
          business_email: this.user.value.business_email.replace(/\s/g, '').toLowerCase(),
          name: this.user.value.name,
          service: this.user.value.service,
          preferred_business: this.user.value.preferred_business,
          // tslint:disable-next-line:max-line-length
          business_phone: (this.user.value.business_phone && this.user.value.business_phone.length ? '+1-' : '') + this.user.value.business_phone,
          phone: '+1-' + this.user.value.phone,
          captcha: this.recaptchaToken,
        };
        this.mainService.api(data, 'business_customer_registration', true, 'object').subscribe((data: any) => {
          if (data.is_error !== 1) {
            if (this.isMobileView) {
              this.openDialog();
            } else {
              this.showThankyou = true;
            }
            // localStorage.setItem('showThankyou', '1');
          } else {
          }
        });
      });
    });
  }

  openDialog() {
    this.dialogRef = this.dialog.open(this.modalTemplate, {
      width: '100%',
      panelClass: 'thankyouModal',
      hasBackdrop: true,
      disableClose: true
    });
  }

  closeDialog() {
    this.dialogRef.close();
    window.open('https://denefits.com/', '_self');

  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {
    // this.openDialog();
  }


}
